/* eslint-disable react/destructuring-assignment,react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Container from 'blocks/Container/Container';
import HTMLParser from 'blocks/Parser/Parser';
import phoneImage from 'common/images/phone.png';
import { ImageSlide as ImageSlideModel } from 'models/index';
import {
  FADE_VALUES,
  delayedOpacityAnimation,
  screenChangeAnimation,
  parallaxImageTranslateY,
} from 'animations/Animations';
import { Bind } from 'lodash-decorators';
import { Row, Column } from 'hedron';
import { reaction } from 'mobx';
import { observer, inject } from 'mobx-react';
import Fade from 'react-reveal/Fade';
import styled from 'styled-components';
import { safeHtmlWithBr } from 'common/methods/string';
import ImageSlideWrapper from './ImageSlideWrapper';
import Background from './Background';
import Title from './Title';
import Description from './Description';
import PhoneImage from './PhoneImage';
import BackgroundImage from './BackgroundImage';
import PhoneWrapper from './PhoneWrapper';
import CurrentImageWrapper from './CurrentImageWrapper';
import PhoneScreenImage from './PhoneScreenImage';
import AbsoluteWrapper from './AbsoluteWrapper';
import PhoneAbsoluteWrapper from './PhoneAbsoluteWrapper';
import PhoneScreenImageWrapper from './PhoneScreenImageWrapper';
import PhoneScenery from './PhoneScenery';
import TitleWrapper from './TitleWrapper';

const PhoneContainer = styled(Container)`
  transition-duration: 0.7s;
  transform: ${({ visible }) => (visible ? 'translateY(0)' : 'translateY(-100vh)')};
  transition-timing-function: ease-in-out;
`;

@inject("windowStore")
@observer
class ImageSlide extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentImageSlideData: props.data,
      previousImageSlideData: props.data,
    };

    this.phoneWrapperRef = React.createRef();
    this.phoneScreenRef = React.createRef();
    this.backgroundImageRef = React.createRef();
    this.absoluteBackgroundImageRef = React.createRef();
    this.titleRef = React.createRef();
    this.descriptionRef = React.createRef();
  }


  componentDidMount() {
    const { windowStore } = this.props;
    this.disposeOnScroll = windowStore.reactToScroll(this.setScrollY);
    this.addReactionToSlideChange();
  }

  componentWillUnmount() {
    this.disposeOnScroll();
    this.disposeReactionToSlideChange();
  }

  static getDerivedStateFromProps(nextProps, lastState) {
    return {
      currentImageSlideData: nextProps.data,
      previousImageSlideData: lastState.currentImageSlideData,
    };
  }


  @Bind
  setScrollY() {
    const backgroundScrollTop = -this.backgroundImageRef.current.getBoundingClientRect().top;
    if (backgroundScrollTop < -450) {
      this.phoneWrapperRef.current.style.top = `${backgroundScrollTop - 160}px`;
    } else if (backgroundScrollTop < -1200) {
      this.phoneWrapperRef.current.style.top = `${500}px`;
    } else {
      this.phoneWrapperRef.current.style.top = `${-515}px`;
    }
    parallaxImageTranslateY(this.backgroundImageRef.current, 150, -150, 8);
    parallaxImageTranslateY(this.absoluteBackgroundImageRef.current, 150, -150, 8);
  }

  addReactionToSlideChange() {
    this.disposeReactionToSlideChange = reaction(
      () => this.props.currentImageIndex,
      () => this.animateOnChange(),
    );
  }

  animateOnChange() {
    const { setCanChangeSlide } = this.props;
    setCanChangeSlide(false);
    screenChangeAnimation(this.phoneScreenRef.current);
    delayedOpacityAnimation([this.backgroundImageRef.current,
      this.titleRef.current, this.descriptionRef.current], 250, () => {
      setCanChangeSlide(true);
    });
  }

  render() {
    const {
      currentImageSlideData,
      previousImageSlideData,
    } = this.state;

    const {
      windowStore,
    } = this.props;

    return (
      <ImageSlideWrapper>

        <AbsoluteWrapper>
          <BackgroundImage
            src={windowStore.adjustImageSize(previousImageSlideData.background)}
            innerRef={this.absoluteBackgroundImageRef}
          />
        </AbsoluteWrapper>

        <CurrentImageWrapper>
          <BackgroundImage
            innerRef={this.backgroundImageRef}
            src={windowStore.adjustImageSize(currentImageSlideData.background)}
          />
        </CurrentImageWrapper>

        <PhoneContainer
          visible={!!currentImageSlideData.image}
        >
          <Row>
            <Column
              xs={12}
              lgShift={6}
              lg={6}
              style={{ padding: 0 }}
            >
              <PhoneScenery>
                <PhoneWrapper
                  innerRef={this.phoneWrapperRef}
                >
                  <PhoneImage
                    src={phoneImage}
                  />
                  <PhoneScreenImageWrapper>
                    <PhoneAbsoluteWrapper>
                      <PhoneScreenImage
                        screenImage={windowStore.adjustImageSize(previousImageSlideData.image)}
                      />
                    </PhoneAbsoluteWrapper>
                    <PhoneScreenImage
                      innerRef={this.phoneScreenRef}
                      screenImage={windowStore.adjustImageSize(currentImageSlideData.image)}
                    />
                  </PhoneScreenImageWrapper>
                </PhoneWrapper>
              </PhoneScenery>
            </Column>
          </Row>
        </PhoneContainer>

        <Background>
          <Container>
            <Row>
              <Column
                style={{
                  paddingTop: 0,
                  paddingBottom: 0,
                }}
                md={6}
                lg={5}
              >
                <TitleWrapper>
                  <Fade
                    distance={`${FADE_VALUES.TEXT.SMALL}`}
                    bottom
                    delay={FADE_VALUES.DELAY.SMALL * 2}
                  >
                    <Title
                      innerRef={this.titleRef}
                      dangerouslySetInnerHTML={
                        { __html: safeHtmlWithBr(currentImageSlideData.header) }
                      }
                    />
                  </Fade>
                </TitleWrapper>
              </Column>
              <Column
                mdShift={1}
                md={5}
                style={{
                  paddingTop: 0,
                  paddingBottom: 0,
                }}
              >
                <Description
                  innerRef={this.descriptionRef}
                >
                  <HTMLParser
                    htmlBody={currentImageSlideData.text}
                  />
                </Description>
              </Column>
            </Row>
          </Container>
        </Background>

      </ImageSlideWrapper>
    );
  }
}
ImageSlide.propTypes = {
  data: PropTypes.instanceOf(ImageSlideModel).isRequired,
  setCanChangeSlide: PropTypes.func.isRequired,
  currentImageIndex: PropTypes.number.isRequired,
};

export default ImageSlide;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/ImageSlide/index.jsx